// extracted by css-extract-rspack-plugin
export default {"logo":"_ad31a3a5","logoSvg":"_25fc2e27"};